var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSizingCostArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D01A1A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00053 5C8.16353 5 8.31653 5.0795 8.41003 5.2135L11.91 10.2135C12.017 10.366 12.029 10.5655 11.944 10.731C11.8575 10.8965 11.687 11 11.5005 11H4.49953C4.31303 11 4.14253 10.8965 4.05603 10.731C3.97103 10.5655 3.98303 10.366 4.09003 10.2135L7.59003 5.2135C7.68353 5.0795 7.83653 5 7.99953 5H8.00053Z",
    fill: "#D01A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSizingCostArrow);
export default __webpack_public_path__ + "static/media/rightSizingCostArrow.c0897fe6b3cbbb8b9ae49706a2f2cf12.svg";
export { ForwardRef as ReactComponent };